/** Money in the console: the API holds integer pence; people type and read pounds (or whatever the currency is). */
import { useQuery } from "@tanstack/react-query";
import { FinanceSettings } from "@workcore/schemas";
import { get } from "./api";
import { wsKey } from "./directory";

export function useCurrency(slug: string): string {
  const s = useQuery({ queryKey: wsKey(slug, "finance-settings"), queryFn: async () => FinanceSettings.parse(await get(`/v1/ws/${slug}/finance-settings`)) });
  return s.data?.currency ?? "GBP";
}

/** 123456 → "£1,234.56" */
export function fmt(pence: number | null | undefined, currency = "GBP"): string {
  if (pence === null || pence === undefined) return "—";
  return new Intl.NumberFormat("en-GB", { style: "currency", currency }).format(pence / 100);
}

/** "1,234.5" → 123450; null for anything that is not an amount with at most two decimal places */
export function toPence(s: string): number | null {
  const t = s.replace(/[£$€,\s]/g, "");
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return null;
  return Math.round(Number(t) * 100);
}

/** 123450 → "1234.50", for an input box */
export const toAmount = (pence: number): string => (pence / 100).toFixed(2);
